module.exports = __webpack_public_path__ + "img/untitled.b6fdef85.png";